var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24Instagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-instagram",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7358",
    "data-name": "Rectangle 7358",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11016",
    "data-name": "Path 11016",
    d: "M9,0A9,9,0,1,1,0,9,9,9,0,0,1,9,0ZM9,3.375c-1.528,0-1.719.006-2.319.034a4.129,4.129,0,0,0-1.365.261A2.876,2.876,0,0,0,3.67,5.315a4.13,4.13,0,0,0-.261,1.365c-.027.6-.034.792-.034,2.319s.006,1.719.034,2.319a4.13,4.13,0,0,0,.261,1.365A2.876,2.876,0,0,0,5.315,14.33a4.13,4.13,0,0,0,1.365.261c.6.027.792.034,2.319.034s1.719-.006,2.319-.034a4.13,4.13,0,0,0,1.365-.261,2.876,2.876,0,0,0,1.645-1.645,4.13,4.13,0,0,0,.261-1.365c.027-.6.034-.792.034-2.319s-.006-1.719-.034-2.319a4.13,4.13,0,0,0-.261-1.365A2.876,2.876,0,0,0,12.685,3.67a4.129,4.129,0,0,0-1.365-.261C10.719,3.381,10.528,3.375,9,3.375ZM9,4.389c1.5,0,1.68.006,2.273.033a3.113,3.113,0,0,1,1.044.194,1.863,1.863,0,0,1,1.068,1.068,3.112,3.112,0,0,1,.194,1.044c.027.593.033.771.033,2.273s-.006,1.68-.033,2.273a3.112,3.112,0,0,1-.194,1.044,1.863,1.863,0,0,1-1.068,1.068,3.112,3.112,0,0,1-1.044.194c-.593.027-.771.033-2.273.033s-1.68-.006-2.273-.033a3.112,3.112,0,0,1-1.044-.194,1.863,1.863,0,0,1-1.068-1.068,3.112,3.112,0,0,1-.194-1.044C4.394,10.68,4.389,10.5,4.389,9s.006-1.68.033-2.273a3.112,3.112,0,0,1,.194-1.044A1.863,1.863,0,0,1,5.683,4.615a3.113,3.113,0,0,1,1.044-.194C7.32,4.394,7.5,4.389,9,4.389ZM9,6.111A2.889,2.889,0,1,0,11.889,9,2.889,2.889,0,0,0,9,6.111Zm0,4.763A1.875,1.875,0,1,1,10.875,9,1.875,1.875,0,0,1,9,10.875ZM12.678,6A.675.675,0,1,1,12,5.322.675.675,0,0,1,12.678,6Z",
    transform: "translate(3 3)",
    fill: "#adb5b9",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Instagram);
export default __webpack_public_path__ + "static/media/icon-24-instagram.222f013d3495b1910c5bf5f8b742f1d5.svg";
export { ForwardRef as ReactComponent };